import React from 'react';
import { reportErrorToBackend } from '../lib/errorCapture';

/**
 * React Error Boundary for catching component tree errors.
 * Reports errors to the backend ingest endpoint and renders a fallback UI.
 * @see .Cursor/plans/error_logging_&_error_ticket_workflow
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const payload = {
      message: error?.message || 'Unknown error',
      name: error?.name,
      stack: error?.stack,
      route: window.location?.pathname,
      buildVersion: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : undefined,
      userAgent: navigator?.userAgent,
      metadata: errorInfo?.componentStack ? { componentStack: errorInfo.componentStack } : undefined,
    };
    reportErrorToBackend(payload);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex flex-col items-center justify-center p-6 bg-gray-50 dark:bg-gray-900">
          <div className="max-w-md w-full text-center space-y-4">
            <h1 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
              Something went wrong
            </h1>
            <p className="text-gray-700 dark:text-gray-300">
              An error has occured, and it has been reported to the dev team, check back soon it
              should be fixed.
            </p>
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Try again
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
